import { FlagSortOrder } from './constants';

export const createdSortFilters = {
  [FlagSortOrder.NEWEST_FIRST]: 'Created newest',
  [FlagSortOrder.OLDEST_FIRST]: 'Created oldest',
};

export const nameSortFilters = {
  [FlagSortOrder.NAME]: 'Name A-Z',
  [FlagSortOrder.NAME_REVERSE]: 'Name Z-A',
};

export const targetingModifiedSortFilterOptions = {
  [FlagSortOrder.TARGETING_MODIFIED_NEWEST_FIRST]: 'Targeting modified newest',
  [FlagSortOrder.TARGETING_MODIFIED_OLDEST_FIRST]: 'Targeting modified oldest',
};

export const getSortFilterOptions = () => ({
  ...createdSortFilters,
  ...nameSortFilters,
});
